import PrefixEnum from '../prefixes'

export default Object.freeze({
    'get-in-shape.gymondo.fitness': PrefixEnum.GET_IN_SHAPE,
})
